import { useFormContext } from 'react-hook-form';
import findUrl from '../../../../utils/findUrl';
import { useSearchContext } from '../../context/Search';
import useGoTo from '../../common/hooks/useGoTo';
import { isNotEmptyArray } from '../../common/utils/helpers';
import { SEARCH_AREA_INPUT_ID } from '../../constants';

const LOGIC_CONSTS = {
  CATEGORY_SUGGESTIONS_ID: 'categorySuggestions',
  PROFILE_SUGGESTIONS_ID: 'profileSuggestions',
  RECENT_SEARCHES_ID: 'recentSearches',
  POLULAR_SEARCHES_ID: 'popularSearches',
};

const useKeywordSuggestionsLogic = ({ maxSuggestionTypes }) => {
  const {
    categorySuggest: { categorySuggestions },
    modal: [, setShowModal],
    popularSearches: { popularSearches },
    profileSuggest: { profileSuggestions },
    recentSearches: { recentSearches },
    selectedKeyword: [, setSelectedKeyword],
    selectedSearchArea: [selectedSearchArea],
  } = useSearchContext();
  const goTo = useGoTo();
  const { setFocus } = useFormContext();

  /**
   * When user clicks a category suggestion, go to the category page
   * @param {Object} suggestion A suggested category
   * @returns {void}
   */
  const handleCategorySuggestionClick = suggestion => {
    setSelectedKeyword(suggestion.name);
    setShowModal(false);
    if (selectedSearchArea) {
      goTo({
        keyword: suggestion.name,
        path: findUrl({
          keywordPath: suggestion.path,
          suburb_url: selectedSearchArea.path,
        }),
        selectedSearchArea,
      });
    } else {
      setFocus(SEARCH_AREA_INPUT_ID);
    }
  };

  /**
   * When user clicks a profile suggestion, go to the profile page
   * @param {Object} suggestion A suggested profile
   * @returns {void}
   */
  const handleProfileSuggestionClick = suggestion => {
    setSelectedKeyword(suggestion.name);
    setShowModal(false);
    goTo({
      keyword: suggestion.name,
      path: suggestion.path,
    });
  };

  /**
   * When user clicks a recent search result, go to it's path
   * @param {Object} suggestion A suggested profile
   * @returns {void}
   */
  const handleRecentSearchesClick = suggestion => {
    setSelectedKeyword(suggestion.name);
    setShowModal(false);
    goTo({
      keyword: suggestion.name,
      path: suggestion.path,
      selectedSearchArea: suggestion.selectedSearchArea,
    });
  };

  /**
   * NOTE: The ordering of this array determines the priority for displaying suggestions
   */
  const allSuggestionTypes = [
    {
      id: LOGIC_CONSTS.CATEGORY_SUGGESTIONS_ID,
      handleSuggestionClick: handleCategorySuggestionClick,
      suggestions: categorySuggestions,
    },
    {
      id: LOGIC_CONSTS.PROFILE_SUGGESTIONS_ID,
      handleSuggestionClick: handleProfileSuggestionClick,
      suggestions: profileSuggestions,
    },
    {
      id: LOGIC_CONSTS.RECENT_SEARCHES_ID,
      handleSuggestionClick: handleRecentSearchesClick,
      suggestions: recentSearches,
    },
    {
      id: LOGIC_CONSTS.POLULAR_SEARCHES_ID,
      handleSuggestionClick: handleCategorySuggestionClick,
      suggestions: popularSearches,
    },
  ]
    .filter(suggestionType => isNotEmptyArray(suggestionType.suggestions))
    .slice(0, maxSuggestionTypes);

  const shownCols = allSuggestionTypes.length;

  return { allSuggestionTypes, shownCols };
};

export default useKeywordSuggestionsLogic;
export { LOGIC_CONSTS };
